import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

const Container = styled.div`
  width: 100%;
  height: fit-content;
`;

const HeaderArea = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
`;

const Icon = styled.div`
  width: 40px;
  height: 40px;
  background-image: ${({ icon }) => `url(${icon})`};
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 16px;
`;

const TitleText = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 130%;
  height: 21px;
  margin-right: 9px;
`;

const TooltipComponent = styled.div`
  padding: 3px 8px;
  width: 278px;
  height: 64px;
  white-space: pre-wrap;
  text-align: center;
`;

const IconTooltip = styled.img`
  margin-top: 6px;
`;

const MainArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      flex-direction: ${({ directionColumn }) => (!directionColumn ? 'row' : 'column')};
    `};
`;

const LeftSide = styled.div`
  width: ${({ device }) => (device === 'mobile' ? '100%' : '25%')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 26px;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      width: 34%;
    `};
`;

const ContainerStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  display: flex;
  .separator {
    width: 1px;
    height: 68px;
    background-color: ${select('middleGray')};
    margin: 4px 18px 0px 12px;
  }
`;

const ContainerValues = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  font-family: 'Hind';
  font-style: normal;
  .value {
    font-weight: 700;
    font-size: ${({ bold }) => (bold ? '42' : '32')}px;
    line-height: ${({ bold }) => (bold ? '130%' : '51px')};
    color: ${({ bold }) => select(bold ? 'black' : 'grayDarkLight')};
  }
  .title {
    width: 73px;
    font-weight: 600;
    font-size: 16px;
    line-height: 130%;
    text-align: center;
    color: ${({ bold }) => select(bold ? 'black' : 'grayDarkLight')};
    background-color: ${({ bold }) => select(bold ? 'grayMedium' : 'transparent')};
    border-radius: ${({ bold }) => (bold ? '8' : '0')}px;
    padding: ${({ bold }) => (bold ? '3px 11px 1px 11px' : '0px')};
  }
`;

const Button = styled.div`
  width: 100%;
  height: 40px;
  border: 1px solid ${({ disabled }) => (disabled ? select('grayMedium') : getColor('primary'))};
  border-radius: 8px;
  display: grid;
  place-items: center;
  :hover {
    background-color: ${({ disabled }) => (!disabled ? getColor('tertiary') : select('white'))};
  }
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  .text {
    font-family: 'Hind';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 130%;
    color: ${({ disabled }) => select(disabled ? 'grayMediumLight' : 'black')};
  }
`;

const Separator = styled.div`
  width: 1px;
  height: 225px;
  background-color: ${select('middleGray')};
  margin: 0px 50px 0px 40px;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      margin: 25px 35px 10px 35px;
      width: ${({ directionColumn }) => (directionColumn ? '100%' : '1px')};
      height: ${({ directionColumn }) => (directionColumn ? '1px' : '225px')};
    `};
  @media screen and (max-width: 1330px) {
    margin: ${({ device }) => device === 'desktop' && '0px 20px 10px 40px'};
  }
`;

const RightSide = styled.div`
  width: 74%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      width: 59%;
    `};
`;

export {
  Container,
  HeaderArea,
  Icon,
  TitleText,
  TooltipComponent,
  IconTooltip,
  MainArea,
  LeftSide,
  ContainerStyled,
  Content,
  ContainerValues,
  Button,
  Separator,
  RightSide
};
